import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { PermissionsActionAdminService } from '../permissions-action-admin.service';
import { PermisiuniService } from '../../permisiuni/permisiuni.service';
import { Observable, finalize, of } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { IPermisiune } from '../../permisiuni/permisiuni.interface';

@Component({
  selector: 'app-add-permissions-action-admin',
  templateUrl: './add-permissions-action-admin.component.html',
  styleUrls: ['./add-permissions-action-admin.component.scss'],
})
export class AddPermissionsActionAdminComponent implements OnInit {
  // general error
  errorTitle: string = environment.config.customNotifications.headers.error;
  errorIcon: string = environment.config.customNotifications.icons.error;
  errorType: string = environment.config.customNotifications.icons.error;

  token!: string;
  isLoading = false;
  isPermissionsLoading = true;
  permissions$!: Observable<IPermisiune[]>;

  form: FormGroup = new FormGroup({
    name: new FormControl(''),
    slug: new FormControl(''),
    id_permission: new FormControl(''),
  });

  constructor(
    private dialogRef: MatDialogRef<AddPermissionsActionAdminComponent>,
    private permissionsActionService: PermissionsActionAdminService,
    private permisiuniService: PermisiuniService,
    private notificationService: NotificationService,
    private authService: AuthService
  ) {
    this.processToken();
  }

  ngOnInit(): void {
    this.getPermisiuniList();
  }

  closeDialog() {
    this.dialogRef?.close({
      success: false,
    });
  }

  processToken() {
    const tokenObj = this.authService.returnTokenUser();
    tokenObj.then((token) => {
      this.token = token;
      this.permissionsActionService.setToken(token);
    });
  }

  getPermisiuniList() {
    this.permissions$ = this.permisiuniService.getPermisiuniList();
    this.permissions$
      .pipe(finalize(() => (this.isPermissionsLoading = false)))
      .subscribe({
        next: (permissions) => {
          this.permissions$ = of(permissions);
          this.isPermissionsLoading = false;
        },
        error: () => {
          let errorMessage =
            environment.config.customNotifications.generalMessages.error;
          this.notificationService.warningSwal(
            this.errorTitle,
            errorMessage,
            this.errorIcon
          );
          this.isPermissionsLoading = false;
        },
      });
  }

  submitForm() {
    this.isLoading = true;

    const permissionsAction = {
      name: this.form.get('name')?.value,
      slug: this.form.get('slug')?.value,
      id_permission: this.form.get('id_permission')?.value,
    };

    this.permissionsActionService
      .addPermissionsAction(permissionsAction)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: () => {
          this.dialogRef.close({ success: true });
        },
        error: () => {
          let errorMessage =
            environment.config.customNotifications.generalMessages.error;
          this.notificationService.warningSwal(
            this.errorTitle,
            errorMessage,
            this.errorIcon
          );
        },
      });
  }
}
